"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var execCommand_1 = require("../utils/execCommand");
/**
 * Toggle italic at selection
 * If selection is collapsed, it will only affect the input after caret
 * If selection contains only italic text, the italic style will be removed
 * If selection contains only normal text, italic style will be added to the whole selected text
 * If selection contains both italic and normal text, italic stlye will be added to the whole selected text
 * @param editor The editor instance
 */
function toggleItalic(editor) {
    execCommand_1.default(editor, "italic" /* Italic */);
}
exports.default = toggleItalic;
//# sourceMappingURL=toggleItalic.js.map